
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.503 16.083"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-notification-center"}},[_c('rect',{attrs:{"id":"Rectangle_11784","data-name":"Rectangle 11784","width":"15.503","height":"16.083","fill":"none","stroke":"#b3b3b3","stroke-width":"1"}})])]),_c('g',{attrs:{"id":"Group_38039","data-name":"Group 38039"}},[_c('g',{attrs:{"id":"Group_38039-2","data-name":"Group 38039","clip-path":"url(#clip-path-notification-center)","fill":"none","stroke":"#b3b3b3","stroke-linejoin":"round","stroke-width":"1"}},[_c('rect',{attrs:{"id":"Rectangle_11783","data-name":"Rectangle 11783","width":"12.807","height":"13.02","rx":"3.138","transform":"translate(.5 2.563)"}}),_c('line',{attrs:{"id":"Line_1131","data-name":"Line 1131","x2":"12.536","transform":"translate(.636 4.99)"}}),_c('line',{attrs:{"id":"Line_1132","data-name":"Line 1132","x1":"6.874","transform":"translate(4.826 .5)","stroke-linecap":"round"}}),_c('path',{attrs:{"id":"Path_28011","data-name":"Path 28011","d":"M15 10.9h0V3.8A3.3 3.3 0 0011.7.5","stroke-linecap":"round"}})])])])
          )
        }
      }
    